import axios from '@utils/axios';

const editTemplateCategory = {
  state: {
    templateCategoryId: 0,
    description: '',
    descriptionEn: '',
    name: '',
    nameEn: '',
    references: ''
  },
  mutations: {
    setTemplateCategoryId(state, id) {
      state.templateCategoryId = id;
    },
    setDescription(state, description) {
      state.description = description;
    },
    setDescriptionEn(state, descriptionEn) {
      state.descriptionEn = descriptionEn;
    },
    setName(state, name) {
      state.name = name;
    },
    setNameEn(state, nameEn) {
      state.nameEn = nameEn;
    },
    setReferences(state, references) {
      state.references = references;
    }
  },
  getters: {
    getDescription(state) {
      return state.description || '';
    },
    getDescriptionEn(state) {
      return state.descriptionEn || '';
    },
    getName(state) {
      return state.name || '';
    },
    getNameEn(state) {
      return state.nameEn || '';
    }
  },
  actions: {
    fetchTemplateCategory(context) {
      return axios.get('admin/templatecategories/getcategory', { params: {
        TemplateCategoryId: context.state.templateCategoryId
      } }).then((res) => {
        context.commit('setDescription', res.data.result.description);
        context.commit('setDescriptionEn', res.data.result.descriptionEn);
        context.commit('setName', res.data.result.name);
        context.commit('setNameEn', res.data.result.nameEn);
        context.commit('setReferences', res.data.result.references);
      });
    },
    editTemplateCategory(context) {
      return axios.patch('admin/templatecategories/edit', {
        CategoryId: context.state.templateCategoryId,
        Description: context.state.description,
        DescriptionEn: context.state.descriptionEn,
        Name: context.state.name,
        NameEn: context.state.nameEn,
        References: context.state.references
      });
    },
    resetContext(context) {
      context.commit('setTemplateCategoryId', 0);
      context.commit('setNameEn', '');
      context.commit('setDescription', '');
      context.commit('setDescriptionEn', '');
      context.commit('setReferences', '');
    }
  },
  namespaced: true
};

export default editTemplateCategory;
